import React, { useState, useRef, useEffect } from 'react';
import { 
  Box, Button, Stack, Grid, FormControlLabel, Radio, RadioGroup, 
  Typography, Paper, Chip, Alert, Autocomplete, Skeleton,
  CircularProgress, TextField, ToggleButton, ToggleButtonGroup, 
  Snackbar
} from '@mui/material';

import SendIcon from '@mui/icons-material/Send';
import SignatureCanvas from 'react-signature-canvas';
import { blue, grey } from '@mui/material/colors';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DownloadIcon from '@mui/icons-material/Download';
import ReturnIcon from '@mui/icons-material/KeyboardReturn';

import BASE_URL from '../../config'


const Inputstyle = {
  '& .MuiOutlinedInput-root': {
    bgcolor: 'white',
    borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
  },
};

const Inputstyle2 = {
  mx: 2,
  '& .MuiOutlinedInput-root': {
    bgcolor: grey[200],
    borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
  },
};

export default function ReporteNuevo({ reporte, alCerrar }) {
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
  const [loading, setLoading] = useState(false);
  const [loadingEnvio, setLoadingEnvio] = useState(false);
  const [loadingPdf, setLoadingPdf] = useState(false);
  
  // Sincronización con datos existentes
  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);
  const [formato, setFormato] = useState(reporte?.formato || 'digital');
  const [pdfArchivoUrl, setPdfArchivoUrl] = useState(reporte?.archivo_pdf_url || '');
  const [observaciones, setObservaciones] = useState(reporte?.comentarios || '');
  const [firmaBorrada, setFirmaBorrada] = useState({ encargado: false, cliente: false });
  const [emailsCC, setEmailsCC] = useState([]); 
  const [urls, setUrls] = useState({ 
    antes: reporte?.foto_antes || '', 
    despues: reporte?.foto_despues || '', 
    firma_encargado_foto: reporte?.firma_encargado || '', 
    firma_cliente_foto: reporte?.firma_cliente || '' 
  });

  const [errorForm, setErrorForm] = useState(false); 
  const [checkList, setCheckList] = useState([]);
  const [emailDestino, setEmailDestino] = useState(reporte?.email_cliente || '');
  const [mensaje, setMensaje] = useState('');

  const sigEncargado = useRef(null);
  const sigCliente = useRef(null);

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const ismailValid = (email) => emailRegex.test(email);
  const mostrarNotificacion = (msg, sev = 'success') => setSnackbar({ open: true, message: msg, severity: sev });

  const getImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http') || url.startsWith('data:') || url.startsWith('blob:')) return url;
    const cleanPath = url.startsWith('/') ? url : `/${url}`;
    return `${BASE_URL}${cleanPath}`;
  };

    // Cargar Checklist del reporte
  useEffect(() => {
    return () => {
      if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);
    };
  }, [pdfBlobUrl]);

  // Cargar Checklist inicial
  useEffect(() => {
    const cargarTareas = async () => {
      try {
        const response = await fetch(`${BASE_URL}/reportes/checklist/${reporte.reporte_id}`);
        const data = await response.json();
        if (data.success) setCheckList(data.data); 
      } catch (err) { console.error("Error checklist:", err); }
    };
    if (reporte?.reporte_id) cargarTareas();
  }, [reporte?.reporte_id]);

  // --- FUNCIÓN MAESTRA DE PREVIEW (SOLUCIÓN AL CACHÉ) ---
  const generarPreview = async () => {
    if (!reporte?.reporte_id) return;
    setLoadingPdf(true);
    try {
      const response = await fetch(
        `${BASE_URL}/reportes/${reporte.reporte_id}/preview?t=${Date.now()}`
      );

      if (!response.ok) throw new Error("Error al obtener el PDF");

      const blob = await response.blob();
      const newUrl = URL.createObjectURL(blob);
      
      // Limpiamos el anterior para evitar fugas de memoria
      setPdfBlobUrl(prev => {
        if (prev) URL.revokeObjectURL(prev);
        return newUrl;
      });

      mostrarNotificacion("Vista previa actualizada");
    } catch (err) {
      console.error(err);
      mostrarNotificacion("Error al generar vista previa", "error");
    } finally {
      setLoadingPdf(false);
    }
  };

  const guardarNuevoReporte = async () => {
    // Validación para formato foto
    if (formato === 'foto' && !pdfArchivoUrl) {
        return mostrarNotificacion("Sube un PDF", "error");
    }

    setLoading(true);
    setLoadingPdf(true);

    try {

      let firmaEncargadoData = urls.firma_encargado_foto;
      if (firmaBorrada.encargado) {
        firmaEncargadoData = ''; // El usuario limpió la firma
      } else if (sigEncargado.current && !sigEncargado.current.isEmpty()) {
        firmaEncargadoData = sigEncargado.current.getCanvas().toDataURL('image/png');
      }

      let firmaClienteData = urls.firma_cliente_foto;
      if (firmaBorrada.cliente) {
        firmaClienteData = ''; // El usuario limpió la firma
      } else if (sigCliente.current && !sigCliente.current.isEmpty()) {
        firmaClienteData = sigCliente.current.getCanvas().toDataURL('image/png');
      }

      const payload = { 
        reporte_id: reporte.reporte_id,
        formato,
        archivo_pdf_url: pdfArchivoUrl,
        foto_antes: urls.antes,
        foto_despues: urls.despues,
        firma_encargado:firmaEncargadoData,
        firma_cliente: firmaClienteData,
        comentarios: observaciones,
        estado: 'cargado',
        check_list: checkList
      };

      const response = await fetch(`${BASE_URL}/reportes/finalizar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        mostrarNotificacion("Reporte guardado con éxito");
        setFirmaBorrada({ encargado: false, cliente: false });
        // Forzamos la regeneración del PDF tras guardar los datos
        await generarPreview(); 
      } else {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al guardar");
      }
    } catch (err) {
      console.error("Error en guardarNuevoReporte:", err);
      mostrarNotificacion(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const urlParaVisor = pdfBlobUrl;

  const handleUpload = async (e, tipo) => {
    const file = e.target.files[0];
    if (!file) return;
    if (tipo === 'pdf_checklist' && file.type !== 'application/pdf') return mostrarNotificacion("Solo se admiten archivos PDF", "error");

    setLoading(true);
    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await fetch(`${BASE_URL}/reportes/upload`, { method: 'POST', body: formData });
      const data = await response.json();
      if (data.success) {
        if (tipo === 'pdf_checklist'){
          setPdfArchivoUrl(data.url);
          mostrarNotificacion("Archivo PDF cargado correctamente");
        }   
        else if (tipo.includes('firma')) setUrls(prev => ({ ...prev, [`${tipo}_foto`]: data.url }));
        else setUrls(prev => ({ ...prev, [tipo]: data.url }));
      }
    } catch (err) { mostrarNotificacion("Error al subir el archivo", "error"); }
    finally { setLoading(false); }
  };

  const handleEnviarReporte = async () => {
    const destinoValido = ismailValid(emailDestino);
    const ccValidos = emailsCC.every(email => ismailValid(email));

    if (!emailDestino || !destinoValido || !ccValidos) {
      setErrorForm(true);
      mostrarNotificacion("Por favor, escribe un correo válido en los campos", "error");
      return;
    }

    setLoadingEnvio(true);
    const data = {
      email_destino: emailDestino,
      cc: emailsCC, 
      mensaje_personalizado: mensaje,
      reporte_id: reporte.reporte_id,
      estado:'enviado'
    };

    try {
      const res = await fetch(`${BASE_URL}/reportes/enviar`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });
      const result = await res.json();
      if (res.ok) {
        mostrarNotificacion("Reporte enviado correctamente");
        setTimeout(() => alCerrar(), 1500);
      } else {
        mostrarNotificacion(result.message || "Error al enviar", "error");
        loadingEnvio(false);
      }
    } catch (err) {
      mostrarNotificacion("Error de conexión", "error");
      setLoadingEnvio(false);
    }
  };

  return (
    <Box sx={{ display:'flex', alignItems:'center', width: '100%', gap:3, flexDirection:'column',justifyContent: 'center',}}>
      <Box sx={{ display:'flex', alignItems:'center', gap:3, flexDirection:'column'}}>
        <Typography variant="h6" align="center" sx={{ fontWeight: 'bold'}}>EDITAR REPORTE TÉCNICO</Typography>
        <Box>
          <ToggleButtonGroup
            value={formato}
            exclusive
            onChange={(e, val) => val && setFormato(val)}
          >
            <ToggleButton value="digital" 
              disabled={pdfArchivoUrl !== '' || reporte?.formato === 'foto'} 
              sx={{ gap: 1.5, borderRadius:2 }}>
              <DescriptionIcon fontSize="small" />
              <Typography variant="body1" sx={{ fontWeight: 'bold', textTransform: 'none' }}>Llenado Digital</Typography>
            </ToggleButton>
            <ToggleButton value="foto" 
              disabled={observaciones !== '' || urls.antes !== '' || reporte?.formato === 'digital'}
              sx={{ gap: 1.5 }}>
              <PictureAsPdfIcon fontSize="small" />
              <Typography variant="body1" sx={{ fontWeight: 'bold', textTransform: 'none' }}>Subir Archivo PDF</Typography>
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>  
      </Box>

      <Box sx={{ display:'flex', gap:3, alignItems:'center', flexDirection:'column', width:'100%'}}>
          <Box sx={{ display:'flex', flexDirection:'column', width:'100%', gap:2, alignItems:'center', justifyContent:'center'}}>
            {formato === 'digital' ? (
              <Stack spacing={4} >
                {/* SECCIÓN 1: FORMULARIO CHECKLIST */}
                <Box sx={{ width: '100%', overflowX: 'hidden' }}>
                  {Object.entries(
                    checkList.reduce((acc, item) => {
                      if (!acc[item.equipo]) acc[item.equipo] = [];
                      acc[item.equipo].push(item);
                      return acc;
                    }, {})
                  ).map(([equipo, tareas]) => (
                    <Paper key={equipo} variant="outlined" sx={{ mb: 4, borderRadius: '8px', overflow: 'hidden', border: '2px solid black', width: '100%' }}>
                      <Box sx={{ bgcolor:'black', p: 1.5 }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'white', textTransform: 'uppercase'}}>Equipo: {equipo}</Typography>
                      </Box>
                      <Box sx={{ display: { xs: 'none', md: 'flex' }, bgcolor:'black', borderBottom:'1px solid white', fontWeight: 'bold' }}>
                        <Box sx={{ width: '40%', p: 1.5, borderRight: '1px solid white', borderTop: '1px solid white', color: 'white'}}>Actividades</Box>
                        <Box sx={{ width: '25%', p: 1.5, borderRight: '1px solid white', borderTop: '1px solid white', color: 'white', textAlign: 'center' }}>Realizado</Box>
                        <Box sx={{ width: '35%', p: 1.5, borderTop: '1px solid white', color: 'white' }}>Comentarios</Box>
                      </Box>
                      {tareas.map((tarea) => {
                        const idx = checkList.findIndex(i => i.tarea_id === tarea.tarea_id && i.equipo === tarea.equipo);
                        return (
                          <Box key={`${tarea.equipo}-${tarea.tarea_id}`} sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, borderBottom: '1px solid #eee', p: { xs: 2, md: 0 }, '&:last-child': { borderBottom: 'none' } }}>
                            <Box sx={{ width: { xs: '100%', md: '40%' }, p: { md: 1.5 }, borderRight: { md: '1px solid #eee' }, mb: { xs: 1, md: 0 } }}>
                              <Typography variant="body2" sx={{ fontWeight: { xs: 'bold', md: 'normal' } }}>{tarea.nombre_tarea}</Typography>
                            </Box>
                            <Box sx={{ width: { xs: '100%', md: '25%' }, p: { md: 1 }, borderRight: { md: '1px solid #eee' }, display: 'flex', justifyContent: 'center', bgcolor: { xs: '#fafafa', md: 'transparent' }, borderRadius: { xs: '4px', md: 0 }, mb: { xs: 1, md: 0 } }}>
                              <RadioGroup
                                row
                                value={String(checkList[idx].realizado)}
                                onChange={(e) => {
                                  const nuevo = [...checkList];
                                  nuevo[idx].realizado = e.target.value === 'true';
                                  setCheckList(nuevo);
                                }}>
                                <FormControlLabel value="true"  control={<Radio size="small" color="success" />} label={<Typography sx={{ fontSize: '0.8rem' }}>SI</Typography>} />
                                <FormControlLabel value="false" control={<Radio size="small" color="error"   />} label={<Typography sx={{ fontSize: '0.8rem' }}>NO</Typography>} />
                              </RadioGroup>
                            </Box>
                            <Box sx={{ width: { xs: '100%', md: '35%' }, p: { md: 1.5 } }}>
                              <TextField fullWidth multiline rows={1} size="small" variant="outlined" placeholder="Escribir comentario..." value={checkList[idx].comentarios || ''} onChange={(e) => {
                                const nuevo = [...checkList];
                                nuevo[idx].comentarios = e.target.value;
                                setCheckList(nuevo);
                              }} sx={{ '& .MuiOutlinedInput-root': { fontSize: '0.8rem', bgcolor: 'white' } }} />
                            </Box>
                          </Box>
                        );
                      })}
                    </Paper>
                  ))}
                </Box>

                {/* SECCIÓN 2: EVIDENCIA FOTOGRAFICA */}
                <Paper variant="outlined" sx={{ p: 2 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2}}>2. Evidencia Fotográfica</Typography>
                  <Box sx={{display:'flex', justifyContent:'space-evenly', flexDirection:{xs:'column', sm:'row'}, alignItems:'center', gap:2}}>
                    {['antes', 'despues'].map(tipo => (
                      <Grid item xs={6} key={tipo}>
                        <Box sx={{ border: '2px dashed #ccc', borderRadius: 2, p: 1, textAlign: 'center', height: '180px', display: 'flex', aspectRatio: '4 / 3', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', position: 'relative', bgcolor: '#f9f9f9' }}>
                          {urls[tipo] ? (
                            <>
                              <IconButton size="small" onClick={() => setUrls(prev => ({ ...prev, [tipo]: '' }))} sx={{ position: 'absolute', top: 8, right: 8, bgcolor: 'rgba(255,255,255,0.8)', '&:hover': { bgcolor: '#ffcdd2', color: 'white' }, boxShadow: 2 }}>
                                <CloseIcon fontSize="small" />
                              </IconButton>
                              <img 
                              src={getImageUrl(urls[tipo])} 
                              alt={`Evidencia ${tipo}`} 
                              style={{ width: '100%', height: '100%', objectFit: 'cover'}}
                              />
                            </>
                          ) : (
                            <Button variant="text" component="label" sx={{ flexDirection: 'column', textTransform: 'none' }}>
                              <Typography variant="subtitle2" color='textSecondary' sx={{ mt: 1 }}>Subir Foto {tipo.toUpperCase()}</Typography>
                              <input type="file" hidden accept="image/*" onChange={(e) => handleUpload(e, tipo)} />
                            </Button>
                          )}
                        </Box>
                      </Grid>
                    ))}
                  </Box>
                </Paper>

                {/* SECCIÓN 3: FIRMAS Y NOTAS */}

                <Paper variant="outlined" sx={{ p:2 }}>
                  <Box sx={{ display:'flex', flexDirection:'column', gap:3 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold'}}>3. Observaciones y Firmas</Typography>
                    <TextField variant='outlined' placeholder="Comentarios adicionales" multiline sx={Inputstyle2} rows={3} value={observaciones} onChange={(e) => setObservaciones(e.target.value)} />
                    <Box sx={{ display:'flex', justifyContent:'space-around', flexDirection:{xs:'column', md:'row'}, gap:3, mx:1 }}>
                      {[ {label: 'Encargado', ref: sigEncargado, urlKey: 'firma_encargado_foto'}, {label: 'Cliente', ref: sigCliente, urlKey: 'firma_cliente_foto'} ].map((f, i) => {
                        const firmaExistente = urls[f.urlKey];
                        const borrada = firmaBorrada[f.label.toLowerCase()];
                        return (
                          <Box key={i}>
                            <Typography variant="subtitle2" display="block" textAlign="center">Firma {f.label}</Typography>
                            {firmaExistente && !borrada && (
                              <Box sx={{ border: '1px solid #ddd', borderRadius: 1, mb: 1, overflow: 'hidden', width: 300, height: 60, bgcolor: 'white' }}>
                                <img src={firmaExistente} alt={`Firma ${f.label}`} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                              </Box>
                            )}
                            <Typography variant="caption" color="textSecondary" display="block" textAlign="center" sx={{ mb: 0.5 }}>
                              {firmaExistente && !borrada ? 'Dibuja para reemplazar' : 'Dibuja la firma'}
                            </Typography>
                            <Box sx={{ border: '1px solid #ccc', bgcolor: '#fafafa', borderRadius:2 }}>
                              <SignatureCanvas
                                ref={f.ref}
                                canvasProps={{width:300, height: 120, className: 'sigCanvas' }}
                                onBegin={() => setFirmaBorrada(prev => ({ ...prev, [f.label.toLowerCase()]: false }))}
                              />
                            </Box>
                            <Button size="small" onClick={() => { f.ref.current.clear(); setFirmaBorrada(prev => ({ ...prev, [f.label.toLowerCase()]: true })); }}
                              sx={{ bgcolor: grey[100], color: 'black', textTransform: 'none', mr:1, '&:hover': { bgcolor: grey[200] }, my:1 }}>
                              Limpiar
                            </Button>
                          </Box>
                        );
                      })}
                    </Box>
                  </Box>
                </Paper>

                {/* SECCIÓN 5: VISTA DEL ARCHIVO PDF GENERADO O CARGADO */}
                {(pdfBlobUrl || loadingPdf) && (
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', borderRadius: 2, border: '2px dashed #ccc', position: 'relative', minHeight: '550px' }}>
                    <Typography variant='body1' color='textSecondary' sx={{ pt: 2 }}>
                      Previsualización del Archivo PDF
                    </Typography>
                    <Box sx={{ position: 'absolute', top: 10, right: 10 }}>
                      <IconButton
                        onClick={async () => {
                          // /download está protegido con token; window.open no lo envía.
                          // Descargamos con fetch (el interceptor añade el token) vía blob.
                          try {
                            const res = await fetch(`${BASE_URL}/reportes/${reporte.reporte_id}/download?t=${Date.now()}`);
                            if (!res.ok) throw new Error('descarga');
                            const blob = await res.blob();
                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = `reporte_${reporte.reporte_id}.pdf`;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                            URL.revokeObjectURL(url);
                          } catch (e) { /* descarga fallida */ }
                        }}
                        sx={{ bgcolor: blue[400], boxShadow: 2, '&:hover': { bgcolor: blue[800] } }}
                        size="medium"
                      >
                        <DownloadIcon sx={{ color:'white' }} />
                      </IconButton>
                    </Box>
                    <Box sx={{ width: '100%', p: { xs: 1, md: 3 }, height: '500px' }}>
                      {loadingPdf ? (
                        <Skeleton variant="rectangular" width="100%" height="100%" sx={{ borderRadius: '8px' }} />
                      ) : (
                        pdfBlobUrl && (
                          <embed
                            key={pdfBlobUrl}
                            src={pdfBlobUrl}
                            type="application/pdf"
                            style={{ width: '100%', height: '100%', border: '1px solid #ddd', borderRadius: '8px' }}
                            title="Visor Reporte"
                          />
                        )
                      )}
                    </Box>
                  </Box>
                )}

                {/* SECCIÓN 6: Enviar Reporte */}
                <Box sx={{ py:2, px: 4, borderRadius: 2, bgcolor:grey[200], display:'flex', gap:2, flexDirection:'column' }}>
                  <Typography variant="h6">Enviar Reporte</Typography>
                  <TextField fullWidth size="small" placeholder="Para ..." value={emailDestino} error={errorForm && (!emailDestino || !ismailValid(emailDestino))} onChange={(e) => setEmailDestino(e.target.value)} sx={Inputstyle} />
                  <Autocomplete multiple freeSolo options={[]} value={emailsCC} onChange={(event, newValue) => setEmailsCC(newValue)} renderTags={(value, getTagProps) => value.map((option, index) => ( <Chip variant="outlined" label={option} {...getTagProps({ index })} color={ismailValid(option) ? "default" : "error"} /> ))} renderInput={(params) => ( <TextField {...params} variant='outlined' placeholder="CC..." size="small" sx={Inputstyle} /> )} />
                  <TextField fullWidth multiline rows={3} value={mensaje} onChange={(e) => setMensaje(e.target.value)} sx={Inputstyle} variant='outlined' placeholder="Mensaje..." />
                  <Box sx={{ display:'flex', flexDirection:'row', justifyContent:'end' }}>   
                    <Button variant="contained" startIcon={loadingEnvio ? <CircularProgress size={20} color="inherit" /> : <SendIcon />} onClick={handleEnviarReporte} sx={{ bgcolor: 'black', textTransform: 'none' }} disabled={loadingEnvio || !emailDestino}>
                      {loadingEnvio ? "Enviando..." : "Enviar"}
                    </Button>
                  </Box>
                </Box>

              </Stack>

            ) : (
              /* VISTA PDF */
              <Box sx={{width:'100%',display:'flex',flexDirection:'column', alignItems:'center'}}>
                <Box sx={{display:'flex',flexDirection:'column',width:{xs:'100%', sm:'40%'},py: 3, px:4,borderRadius: 2, border: '2px dashed #ccc'}}>
                  {!pdfArchivoUrl &&  (
                    <Button variant="contained" component="label" sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, '&:hover': { bgcolor: '#333' } }}>
                      Seleccionar PDF Escaneado
                      <input type="file" hidden accept=".pdf" onChange={(e) => handleUpload(e, 'pdf_checklist')} />
                    </Button>
                  )}
                  {pdfArchivoUrl && (
                    <Box sx={{ width: '100%', position: 'relative' }}>
                      <IconButton onClick={() => setPdfArchivoUrl('')} sx={{ position: 'absolute', top: -10, right: -10, bgcolor: 'white', boxShadow: 2, '&:hover': { bgcolor: '#f5f5f5', color: 'error.main' } }} size="small">
                        <CloseIcon fontSize="small" />
                      </IconButton>
                      <Box sx={{ width: '100%', borderRadius: '8px', overflow: 'hidden', border: '1px solid #ddd', height:'500px' }}>
                        <embed src={pdfArchivoUrl.startsWith('http') ? pdfArchivoUrl : `${BASE_URL}${pdfArchivoUrl}`} type="application/pdf" width="100%" height="100%" />
                      </Box>
                    </Box>
                  )}
                </Box>
                {/* SECCIÓN 6: Enviar Reporte */}
                {pdfArchivoUrl && (
                  <Box sx={{alignSelf:'center',mt:3, py:2, px: 4, borderRadius: 2, bgcolor:grey[200],width:{xs:'100%', sm:'30%'}, display:'flex', gap:2, flexDirection:'column' }}>
                    <Typography variant="h6">Enviar Reporte</Typography>
                    <TextField fullWidth size="small" placeholder="Para ..." value={emailDestino} error={errorForm && (!emailDestino || !ismailValid(emailDestino))} onChange={(e) => setEmailDestino(e.target.value)} sx={Inputstyle} />
                    <Autocomplete multiple freeSolo options={[]} value={emailsCC} onChange={(event, newValue) => setEmailsCC(newValue)} renderTags={(value, getTagProps) => value.map((option, index) => ( <Chip variant="outlined" label={option} {...getTagProps({ index })} color={ismailValid(option) ? "default" : "error"} /> ))} renderInput={(params) => ( <TextField {...params} variant='outlined' placeholder="CC..." size="small" sx={Inputstyle} /> )} />
                    <TextField fullWidth multiline rows={3} value={mensaje} onChange={(e) => setMensaje(e.target.value)} sx={Inputstyle} variant='outlined' placeholder="Mensaje..." />
                    <Box sx={{ display:'flex', flexDirection:'row', justifyContent:'end' }}>   
                      <Button variant="contained" startIcon={loadingEnvio ? <CircularProgress size={20} color="inherit" /> : <SendIcon />} onClick={handleEnviarReporte} sx={{ bgcolor: 'black', textTransform: 'none' }} disabled={loadingEnvio || !emailDestino}>
                        {loadingEnvio ? "Enviando..." : "Enviar"}
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
              )}
            <Stack direction="row" spacing={2} sx={{ width: '100%', justifyContent: 'center', mt: 2 }}>
              <Button 
                variant="contained" 
                sx={{ bgcolor: grey[100], color: 'black', textTransform: 'none', px: 3, '&:hover': { bgcolor: grey[200] } }} 
                onClick={alCerrar} 
                startIcon={<ReturnIcon/>}
                disabled={loadingEnvio || loading}>Regresar al menú
              </Button>
              <Button 
                variant="contained" 
                sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 6, '&:hover': { bgcolor: 'black' } }} 
                onClick={guardarNuevoReporte} 
                disabled={loadingEnvio || loading || (formato === 'foto' && !pdfArchivoUrl)}
                >
                {loading ? <CircularProgress size={24} color="inherit" /> : "Guardar Cambios"}
              </Button>
            </Stack>
          </Box>

      </Box>

      <Snackbar open={snackbar.open} autoHideDuration={2000} onClose={() => setSnackbar({...snackbar, open: false})} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}